import React from 'react';
import { Link } from 'react-router-dom';
import logo from'./images/logo.png'



function Navbar (props){
return(
<nav className="navbar navbar-expand-xxl navbar-dark ">
    <div className="container-fluid">
      <div className='nav-button'><button type="button" className="btn btn-secondary menu-button" id="menu-b" onClick={(e) => props.setState(!props.state)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
          <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
        </svg></button></div>
      <a className="navbar-brand" > 
        <h2> ГПНТБ России</h2>
      </a>
      <div className="image">
        <img src={logo} className="logo" height="95" width="95"/>
      </div>
    </div>
    </nav>
    
    
    
    );





} ;



export default Navbar